import { useComputed } from '@legendapp/state/react';
import type { Observable } from '@legendapp/state';
import { cartItemReferenceStoreAPI } from '../stores';

/**
 * useCartTotalItems - Computes total quantity of items in cart from CartItemReference store
 *
 * Computes directly from CartItemReference store.
 * Only counts references that have a valid `cartItem` attached (i.e., synced with server).
 *
 * @returns Observable<number> - reactive total item count
 */
export function useCartTotalItems(): Observable<number> {
    return useComputed(() => {
        const refs = cartItemReferenceStoreAPI.state.getItemsObservable().get() ?? [];
        return refs.filter(ref => ref?.cartItem).reduce((sum, ref) => sum + (ref?.qty ?? 0), 0);
    });
}
